import React from "react";
import {Button, Col, Row, Spin } from 'antd'
import "../../Styles/Services/checkInvoiceCSV.css"
import {connect} from "react-redux";
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors";
import {withRouter} from "react-router-dom";
import BaseDocumentControl from "./BaseDocumentControl";
import EditDocument from "../../Components/Documents/EditDocument";
import DocumentTable from "../../Components/Documents/DocumentTable";

class Documents extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            step: 'documentList',
            documentView: null
        }
        this.editDocument = this.editDocument.bind(this)
    }

    editDocument(document) {
        this.setState({documentView: document, step: 'documentView'}, () => {console.log(document)})
    }

    render() {
        if (this.state.step === 'documentList') {
            return (
                <BaseDocumentControl
                    selected='documents'>
                   <DocumentTable
                        editDocument={this.editDocument}
                   />
                </BaseDocumentControl>
            )
        } else if (this.state.step === 'documentView') {
            return (
                <BaseDocumentControl selected='documents'>
                    <EditDocument document={this.state.documentView}/>
                    <Button type="primary" onClick={() => this.setState({step: 'documentList', documentView: null })}
                            style={{marginTop: '10px'}}>Volver</Button>
                </BaseDocumentControl>
            )
        }

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Documents))
